import { createSlice } from '@reduxjs/toolkit';

let initialState = {
  codeInfo: [], // 코드 정보
};

const CodeInfoSlice = createSlice({
  name: 'CodeInfo',
  initialState,
  reducers: {
    setCodeInfo(state, action) {
      state.codeInfo = action.payload;
    },
  },
});

export const CodeInfoActions = CodeInfoSlice.actions;
export default CodeInfoSlice.reducer;
